import Vue from 'vue';
import Vuex from 'vuex';
import axios from "axios";
import {URL_BASE} from './mixins'
import { mapGetters } from 'vuex'
Vue.use(Vuex);
export const store=new Vuex.Store({
    state: {
        auth: false,
        token:"",
        secret_key_token: "Sdw1s9x8@",
        usuario: '',
        dataLocales:[],
        dataPersonal:[],
        dataUbigeo:[],
        dataCombustibleTipo:[],
        dataDepartamento:[],
        dataDetalleTrimovil:[],
        dataSelectsBajaj:[],
        dataSelectsTVS:[]
    },
    getters:{
      token: state => state.token
    },
    mutations:{
        iniciar_sesion:(state)=>state.auth=!state.auth,
        acceso_salir:(state)=>state.nivel_acceso="0",
        cerrar_session:(state)=>state.auth=false,
        cambiar_nivelAcceso(state,payload){
            state.nivel_acceso=payload.nivel;
        },
        setLocales:(state,payload)=>state.dataLocales=payload,
        setPersonal:(state,payload)=>state.dataPersonal=payload,
        setDepartamento:(state,payload)=>state.dataDepartamento=payload,
        setCombustibleTipo:(state,payload)=>state.dataCombustibleTipo=payload,
        setDetalleTrimovil:(state,payload)=>state.dataDetalleTrimovil=payload,
        setUbigeo:(state,payload)=>state.dataUbigeo=payload,
        setToken:(state,payload)=>state.token=payload,
        setUsuario:(state,payload)=>state.usuario=payload,
        setSelectBajaj:(state,payload)=>state.dataSelectsBajaj=payload,
        setSelectTvs:(state,payload)=>state.dataSelectsTVS=payload,
    },
    actions:{
        getLocales: async (context)=>{
            axios.get(URL_BASE+"locales").then(respuesta => {
              context.commit("setLocales",respuesta.data);
            }).catch(function (error) {
              console.log("er store"+error);
            });
        },
        getPersonal: async (context)=>{
            axios.post(URL_BASE+"personas/read").then(respuesta => {
              context.commit("setPersonal",respuesta.data.data);
            }).catch(function (error) {
              console.log("er store"+error);
            });
        },
        getCombustibleTipo: async (context)=>{
            axios.get(URL_BASE+"combustibles_tipo").then(respuesta => {
              context.commit("setCombustibleTipo",respuesta.data.data);
            }).catch(function (error) {
              console.log("er store"+error);
            });
        },
        getDepartamento: async (context)=>{
            axios.get(URL_BASE+"ubigeos/departamentos").then(respuesta => {
              context.commit("setDepartamento",respuesta.data);
            }).catch(function (error) {
              console.log("er store"+error);
            });
        },
        getDetalleTrimovil: async (context)=>{
          await  axios.get(URL_BASE+"detalle_trimovil").then(respuesta => {
              context.commit("setDetalleTrimovil",respuesta.data.data);
            }).catch(function (error) {
              console.log("er store"+error);
            });
        },
        getUbigeo: async (context)=>{
            axios.get(URL_BASE+"ubigeos").then(respuesta => {
              context.commit("setUbigeo",respuesta.data);
            }).catch(function (error) {
              console.log("er store"+error);
            });
        },
        getSelects: async (context)=>{
            axios.post(URL_BASE+"trimovil/getSelect").then(respuesta => {
              context.commit("setSelectBajaj",respuesta.data.bajaj);
              context.commit("setSelectTvs",respuesta.data.tvs);
            }).catch(function (error) {
              console.log("er store"+error);
            });
        },
    },
    computed: {
      ...mapGetters([
        'token'
      ])
    }
});